module.exports = __webpack_public_path__ + "img/GlobeChek.94c779b9.jpg";